import { Color } from '@diritto/common/style/color';
import styled from '@emotion/styled';

export const EventBadge = () => (
  <StyledWrapper>
    <p>이벤트</p>
  </StyledWrapper>
);

const StyledWrapper = styled.span`
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid ${Color.Blue200};
  border-radius: 100px;
  padding: 0 8px;

  & > p {
    font-size: 12px;
    line-height: 18px;
    color: ${Color.Blue500};
  }
`;
